export default "__VITE_ASSET__DzsYBUPg__"